import Pagseguro from '@/payments/pagseguro'
import Yapay from '@/payments/yapay'
import Mercadopago from '@/payments/mercadopago'

const payments = {
  pagseguro: {
    ...Pagseguro
  },
  yapay: {
    ...Yapay
  },
  mercadopago: {
    ...Mercadopago
  }
}

export default {
  getPayment (type) {
    return payments[type]
  }
}
